import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  ApiGetGrupoEmpresaByClient,
  ApiSaveGrupoEmpresa,
  ApiUpdateGrupoEmpresa,
  ApiDeleteGrupoEmpresa
} from './grupoEmpresa.api';

export const getGrupoEmpresaList = createAsyncThunk(
  'api/gruposempresa',
  async ({ clientId }) => {
    let response = await ApiGetGrupoEmpresaByClient({ clientId });
    return response;
  }
);

export const saveGrupoEmpresa = createAsyncThunk(
  'api/savegrupoempresa',
  async ({ nome, client_id }) => {
    let response = await ApiSaveGrupoEmpresa({ nome, client_id });
    return response;
  }
);

export const updateGrupoEmpresa = createAsyncThunk(
  'api/updategrupoempresa',
  async ({ id, nome }) => {
    let response = await ApiUpdateGrupoEmpresa({ id, nome });
    return response;
  }
);

export const deleteGrupoEmpresa = createAsyncThunk(
  'api/deletegrupoempresa',
  async ({ id }) => {
    let response = await ApiDeleteGrupoEmpresa({ id });
    return response;
  }
);

export const grupoEmpresaSlice = createSlice({
  name: 'grupoEmpresa',
  initialState: {
    grupos: [],
    isGettingGrupos: false,
    saveGrupoEmpresa: {},
    isSaveGrupoEmpresa: false,
    isUpdatingGrupoEmpresa: false,
    isDeletingGrupoEmpresa: false
  },
  reducers: {
    // Limpa a lista ao trocar de cliente no formulário de Empresa - senão os
    // grupos do cliente anterior ficariam visíveis por um instante.
    limparGruposEmpresa: (state) => {
      state.grupos = [];
    }
  },
  extraReducers: {
    [getGrupoEmpresaList.pending]: (state) => {
      state.isGettingGrupos = 'loading';
    },
    [getGrupoEmpresaList.fulfilled]: (state, action) => {
      state.isGettingGrupos = 'success';
      state.grupos = action.payload;
    },
    [getGrupoEmpresaList.rejected]: (state) => {
      state.isGettingGrupos = 'failed';
    },
    [saveGrupoEmpresa.pending]: (state) => {
      state.isSaveGrupoEmpresa = 'loading';
    },
    [saveGrupoEmpresa.fulfilled]: (state, action) => {
      state.isSaveGrupoEmpresa = 'success';
      state.saveGrupoEmpresa = action.payload;
      // Some endpoints (`grupo_empresa/save`) já devolvem o registro criado -
      // adiciona na lista local pra aparecer no select sem precisar recarregar.
      if (action.payload?.Id) state.grupos = [...state.grupos, action.payload];
    },
    [saveGrupoEmpresa.rejected]: (state) => {
      state.isSaveGrupoEmpresa = 'failed';
    },
    [updateGrupoEmpresa.pending]: (state) => {
      state.isUpdatingGrupoEmpresa = 'loading';
    },
    [updateGrupoEmpresa.fulfilled]: (state) => {
      state.isUpdatingGrupoEmpresa = 'success';
    },
    [updateGrupoEmpresa.rejected]: (state) => {
      state.isUpdatingGrupoEmpresa = 'failed';
    },
    [deleteGrupoEmpresa.pending]: (state) => {
      state.isDeletingGrupoEmpresa = 'loading';
    },
    [deleteGrupoEmpresa.fulfilled]: (state) => {
      state.isDeletingGrupoEmpresa = 'success';
    },
    [deleteGrupoEmpresa.rejected]: (state) => {
      state.isDeletingGrupoEmpresa = 'failed';
    }
  }
});

export const { limparGruposEmpresa } = grupoEmpresaSlice.actions;
export const grupoEmpresaSelector = (state) => state.grupoEmpresa;
export default grupoEmpresaSlice.reducer;
